import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import { useCourse } from '../contexts/CourseContext';

export function usePreferencesStatus() {
  const { currentCourse } = useCourse();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [hasPreferences, setHasPreferences] = useState<boolean>(false);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      setLoading(true);
      try {
        if (!currentCourse) {
          setHasPreferences(false);
          return;
        }
        const { data: { user } } = await supabase.auth.getUser();
        if (!user) {
          setHasPreferences(false);
          return;
        }
        const { data, error } = await supabase
          .from('course_learner_preferences')
          .select('learning_preference, course_preferred_name')
          .eq('user_id', user.id)
          .eq('course_id', currentCourse.id)
          .maybeSingle();

        if (error && (error as any).code !== 'PGRST116') {
          console.warn('[usePreferencesStatus] Error fetching preferences:', error);
          setHasPreferences(false);
          return;
        }

        const lpText = (data?.learning_preference ?? '').toString().trim();
        const hasMinLength = lpText.length >= 10; // require minimum length of 10
        if (!cancelled) setHasPreferences(hasMinLength);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    // Re-check on course change and route changes so UI reflects latest state.
    load();
    return () => { cancelled = true; };
  }, [currentCourse, location.pathname]);

  return { loading, hasPreferences } as const;
}
